import api from 'data/api';

export const loadTrafficTypes = api('GET /api/mobile/lookups/traffictypes');
